var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import themes from "../../assets/themes";
export var PasswordCheckContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
export var Check = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 12px;\n  text-align: left;\n  padding-top: 9px;\n  color: ", ";\n"], ["\n  font-size: 12px;\n  text-align: left;\n  padding-top: 9px;\n  color: ", ";\n"])), themes.colors.grey);
var templateObject_1, templateObject_2;
